import React from 'react'
import { RolesCellStyles } from './Style'
import RoleCell from './RoleCell'

const RolesCell = (props) => {
    const { getValue } = props
    const roles = getValue()

    return (
        <RolesCellStyles>
            {roles?.map((role) =>
                <RoleCell role={role} />
            )}
        </RolesCellStyles>
    )
}

export default RolesCell